import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaUser, FaSearch } from "react-icons/fa";
import getImageUrl from "../../../utils/imageUtils";
import Loader from "../../common/Loader";
import styles from "../../../styles/components/profile/PublicUserProfile.module.css";

const FollowersFollowingModal = ({
  isOpen,
  type, // "followers" or "following"
  onClose,
  list,
  loading,
}) => {
  const [search, setSearch] = useState("");

  // Reset search when modal closes
  useEffect(() => {
    if (!isOpen) {
      setSearch("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const filteredList = list.filter((item) => {
    if (!search.trim()) return true;
    const searchLower = search.toLowerCase();
    const fullName = `${item.firstName} ${item.lastName}`.toLowerCase();
    const username = item.username?.toLowerCase() || "";
    return (
      fullName.includes(searchLower) ||
      username.includes(searchLower) ||
      item.firstName?.toLowerCase().includes(searchLower) ||
      item.lastName?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>{type === "followers" ? "Followers" : "Following"}</h2>
          <button
            type="button"
            className={styles.modalClose}
            onClick={onClose}
            aria-label="Close dialog"
          >
            ×
          </button>
        </div>
        <div className={styles.modalSearchContainer}>
          <div className={styles.searchInputWrapper}>
            <FaSearch className={styles.searchIcon} />
            <input
              type="text"
              placeholder={`Search ${type}...`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className={styles.searchInput}
            />
          </div>
        </div>
        <div
          className={`${styles.modalBody}${
            !loading && filteredList.length > 0 ? ` ${styles.modalBodyList}` : ""
          }`}
        >
          {loading ? (
            <Loader inline={true} />
          ) : filteredList.length > 0 ? (
            filteredList.map((item) => (
              <Link
                key={item._id}
                to={`/user/${item._id}`}
                className={styles.userCard}
                onClick={onClose}
              >
                {item.avatar ? (
                  <img
                    src={getImageUrl(item.avatar)}
                    alt={item.firstName}
                    className={styles.userAvatar}
                  />
                ) : (
                  <div className={styles.userAvatarPlaceholder}>
                    <FaUser />
                  </div>
                )}
                <div className={styles.userCardInfo}>
                  <div className={styles.userCardName}>
                    {item.firstName} {item.lastName}
                  </div>
                  {item.username && (
                    <div className={styles.userCardUsername}>
                      @{item.username}
                    </div>
                  )}
                </div>
              </Link>
            ))
          ) : list.length > 0 ? (
            <div className={styles.emptyState}>
              <p>No {type} match your search</p>
            </div>
          ) : (
            <div className={styles.emptyState}>
              <p>No {type} yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowersFollowingModal;
